module.exports = __webpack_public_path__ + "img/logo-assinatura-brasil.1ba19ab3.png";